// Initialize variables
let countdownInterval;
let remainingTime = 150; // 2 minutes and 30 seconds

// DOM elements
const phoneStep = document.getElementById("b6-step-phone");
const otpStep = document.getElementById("b6-step-otp");
const userInfoStep = document.getElementById("b6-step-user-info");
const phoneForm = document.getElementById("b6-phone-form");
const otpForm = document.getElementById("b6-otp-form");
const userInfoForm = document.getElementById("b6-user-info-form");
const phoneInput = document.getElementById("b6-phone");
const otpInput = document.getElementById("b6-otp");
const hiddenPhoneInput = document.getElementById("b6-hidden-phone");
const hiddenPhoneInfoInput = document.getElementById("b6-hidden-phone-info");
const phoneError = document.getElementById("b6-phone-error");
const otpError = document.getElementById("b6-otp-error");
const userInfoError = document.getElementById("b6-user-info-error");
const editPhoneLink = document.getElementById("b6-edit-phone");
const resendOtpLink = document.getElementById("b6-resend-otp");
const countdownTimer = document.getElementById("b6-countdown");
const countdownContainer = document.getElementById("b6-countdown-timer");

/**
 * Format time as MM:SS
 */
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
}

/**
 * Start countdown timer
 */
function startCountdown() {
  // Reset timer
  remainingTime = 150;
  countdownTimer.textContent = formatTime(remainingTime);

  // Show countdown, hide resend link
  countdownContainer.style.display = "block";
  resendOtpLink.style.display = "none";

  // Clear any existing interval
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }

  // Start new interval
  countdownInterval = setInterval(function () {
    remainingTime--;
    countdownTimer.textContent = formatTime(remainingTime);

    if (remainingTime <= 0) {
      clearInterval(countdownInterval);
      countdownContainer.style.display = "none";
      resendOtpLink.style.display = "block";
    }
  }, 1000);
}

/**
 * Show loading state on button
 */
function showLoading(button) {
  button.classList.add("loading");
  button.disabled = true;
}

/**
 * Hide loading state on button
 */
function hideLoading(button) {
  button.classList.remove("loading");
  button.disabled = false;
}

/**
 * Show error message
 */
function showError(element, message) {
  element.textContent = message;
  element.parentElement.classList.add("has-error");
}

/**
 * Clear error message
 */
function clearError(element) {
  element.textContent = "";
  element.parentElement.classList.remove("has-error");
}

/**
 * Go to OTP step
 */
function goToOtpStep(phone) {
  phoneStep.style.display = "none";
  otpStep.style.display = "block";
  userInfoStep.style.display = "none";

  // Set phone in hidden field
  hiddenPhoneInput.value = phone;

  // Focus on OTP input
  otpInput.focus();

  // Start countdown
  startCountdown();
}

/**
 * Go to user info step
 */
function goToUserInfoStep(phone) {
  phoneStep.style.display = "none";
  otpStep.style.display = "none";
  userInfoStep.style.display = "block";

  // Set phone in hidden field
  hiddenPhoneInfoInput.value = phone;

  // Focus on first name input
  document.getElementById("b6-first-name").focus();
}

/**
 * Go back to phone step
 */
function goToPhoneStep() {
  phoneStep.style.display = "block";
  otpStep.style.display = "none";
  userInfoStep.style.display = "none";

  // Clear OTP input
  otpInput.value = "";

  // Clear any errors
  clearError(otpError);

  // Stop countdown
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
}

/**
 * Send AJAX request
 */
function sendAjaxRequest(
  url,
  data,
  successCallback,
  errorCallback,
  finallyCallback
) {
  // Create form data
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  // Send request
  fetch(url, {
    method: "POST",
    body: formData,
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    })
    .finally(() => {
      if (finallyCallback) finallyCallback();
    });
}

/**
 * Serialize form data
 */
function serializeForm(form) {
  const formData = new FormData(form);
  const data = {};

  for (const [key, value] of formData.entries()) {
    data[key] = value;
  }

  return data;
}

/**
 * Initialize event listeners
 */
function initEventListeners() {
  // Phone form submission
  if (phoneForm) {
    phoneForm.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Clear any previous errors
      clearError(phoneError);

      // Get phone number
      const phone = phoneInput.value.trim();

      // Validate phone number
      if (!phone) {
        showError(phoneError, "لطفا شماره موبایل خود را وارد کنید");
        return;
      }

      if (!/^09[0-9]{9}$/.test(phone)) {
        showError(phoneError, "شماره موبایل نامعتبر است");
        return;
      }

      // Show loading
      const submitBtn = phoneForm.querySelector('button[type="submit"]');
      showLoading(submitBtn);

      // Send AJAX request
      const formData = serializeForm(phoneForm);

      sendAjaxRequest(
        b6_login_params.ajax_url,
        formData,
        function (response) {
          if (response.success) {
            // Go to OTP step
            goToOtpStep(phone);
          } else {
            // Show error
            showError(
              phoneError,
              response.data.message || "خطایی رخ داد. لطفا دوباره تلاش کنید"
            );
          }
        },
        function () {
          showError(phoneError, "خطا در ارتباط با سرور. لطفا دوباره تلاش کنید");
        },
        function () {
          hideLoading(submitBtn);
        }
      );
    });
  }

  // OTP form submission
  if (otpForm) {
    otpForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Clear any previous errors
      clearError(otpError);

      // Get OTP code
      const otp = otpInput.value.trim();
      const phone = hiddenPhoneInput.value;

      // Validate OTP
      if (!otp) {
        showError(otpError, "لطفا کد تایید را وارد کنید");
        return;
      }

      if (!/^[0-9]{5}$/.test(otp)) {
        showError(otpError, "کد تایید باید 5 رقم باشد");
        return;
      }

      // Show loading
      const submitBtn = otpForm.querySelector('button[type="submit"]');
      showLoading(submitBtn);

      // Send AJAX request
      const formData = serializeForm(otpForm);

      sendAjaxRequest(
        b6_login_params.ajax_url,
        formData,
        function (response) {
          if (response.success) {
            // Stop countdown
            if (countdownInterval) {
              clearInterval(countdownInterval);
            }

            if (response.data.is_new_user) {
              // Go to user info step for new users
              goToUserInfoStep(phone);
            } else {
              // Redirect existing users
              window.location.href = response.data.redirect;
            }
          } else {
            // Show error
            showError(
              otpError,
              response.data.message || "کد وارد شده اشتباه است"
            );
          }
        },
        function () {
          showError(otpError, "خطا در ارتباط با سرور. لطفا دوباره تلاش کنید");
        },
        function () {
          hideLoading(submitBtn);
        }
      );
    });
  }

  // User info form submission
  if (userInfoForm) {
    userInfoForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Clear any previous errors
      clearError(userInfoError);

      // Get form data
      const firstName = document.getElementById("b6-first-name").value.trim();
      const lastName = document.getElementById("b6-last-name").value.trim();

      // Validate form data
      if (!firstName) {
        showError(userInfoError, "لطفا نام خود را وارد کنید");
        return;
      }

      if (!lastName) {
        showError(userInfoError, "لطفا نام خانوادگی خود را وارد کنید");
        return;
      }

      // Show loading
      const submitBtn = userInfoForm.querySelector('button[type="submit"]');
      showLoading(submitBtn);

      // Send AJAX request
      const formData = serializeForm(userInfoForm);

      sendAjaxRequest(
        b6_login_params.ajax_url,
        formData,
        function (response) {
          if (response.success) {
            // Redirect to account page or callback URL
            window.location.href = response.data.redirect;
          } else {
            // Show error
            showError(
              userInfoError,
              response.data.message || "خطایی رخ داد. لطفا دوباره تلاش کنید"
            );
          }
        },
        function () {
          showError(
            userInfoError,
            "خطا در ارتباط با سرور. لطفا دوباره تلاش کنید"
          );
        },
        function () {
          hideLoading(submitBtn);
        }
      );
    });
  }

  // Edit phone link click
  if (editPhoneLink) {
    editPhoneLink.addEventListener("click", function (e) {
      e.preventDefault();
      goToPhoneStep();
    });
  }

  // Resend OTP link click
  if (resendOtpLink) {
    resendOtpLink.addEventListener("click", function (e) {
      e.preventDefault();

      // Clear any previous errors
      clearError(otpError);

      // Get phone number
      const phone = hiddenPhoneInput.value;

      // Show loading
      this.classList.add("loading");
      this.disabled = true;

      // Send AJAX request
      sendAjaxRequest(
        b6_login_params.ajax_url,
        {
          action: "b6_resend_otp",
          phone: phone,
          b6_resend_nonce: b6_login_params.resend_nonce,
        },
        function (response) {
          if (response.success) {
            // Start countdown again
            startCountdown();
          } else {
            // Show error
            showError(
              otpError,
              response.data.message || "خطایی رخ داد. لطفا دوباره تلاش کنید"
            );
          }
        },
        function () {
          showError(otpError, "خطا در ارتباط با سرور. لطفا دوباره تلاش کنید");
        },
        function () {
          resendOtpLink.classList.remove("loading");
          resendOtpLink.disabled = false;
        }
      );
    });
  }

  // Format phone number as user types
  if (phoneInput) {
    phoneInput.addEventListener("input", function (e) {
      let value = this.value.replace(/\D/g, "");

      // Ensure it starts with 09
      if (value.length > 0 && value.charAt(0) !== "0") {
        value = "0" + value;
      }
      if (value.length > 1 && value.charAt(1) !== "9") {
        value = value.charAt(0) + "9" + value.substring(2);
      }

      // Limit to 11 digits
      if (value.length > 11) {
        value = value.substring(0, 11);
      }

      this.value = value;

      if (value.length === 11) {
        setTimeout(() => {
          const event = new Event("submit");
          phoneForm.dispatchEvent(event);
        }, 200);
      }
    });
  }

  // Format OTP code as user types
  if (otpInput) {
    otpInput.addEventListener("input", function () {
      let value = this.value.replace(/\D/g, "");

      // Limit to 5 digits
      if (value.length > 5) {
        value = value.substring(0, 5);
      }

      this.value = value;

      if (value.length === 5) {
        setTimeout(() => {
          const event = new Event("submit");
          otpForm.dispatchEvent(event);
        }, 200);
      }
    });
  }
}

// Initialize when DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // console.log("login-signup.js");
  initEventListeners();
});
